import clsx from "clsx"
import { ReactNode } from "react"

export type InputLabelProps = {
  htmlFor: string
  elevated: boolean
  hasError?: boolean
  children: ReactNode
}

export const InputLabel = ({ htmlFor, children, elevated, hasError }: InputLabelProps) => {
  return (
    <label
      htmlFor={htmlFor}
      className={clsx("pointer-events-none absolute top-0 left-[13px] z-1 origin-left px-1 transition-transform", {
        "translate-y-[12px]": !elevated,
        "-translate-y-[10px] scale-75 rounded bg-white": elevated,
        "text-np-error!": hasError,
      })}
    >
      {children}
    </label>
  )
}
